import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faBook, 
    faShieldAlt, 
    faUser, 
    faBuilding, 
    faFileAlt, 
    faCheckCircle, 
    faExclamationTriangle, 
    faPrint, 
    faPaperPlane, 
    faArrowLeft,
    faPhone,
    faEnvelope,
    faMapMarkerAlt,
    faIdCard,
    faShoppingBag,
    faInfoCircle
} from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import baseURL from '../../Components/url';
import Swal from 'sweetalert2';
import libroLogoBlanco from '../../images/libro-reclamaciones-blanco.png';
import './LibroReclamaciones.css';

export default function LibroReclamaciones() {
    const [contacto, setContacto] = useState({});
    const [enviando, setEnviando] = useState(false);
    const [reclamoExitoso, setReclamoExitoso] = useState(null);

    // Formulario
    const [formData, setFormData] = useState({
        tipoPersona: 'Natural',
        nombres: '',
        apellidos: '',
        tipoDocumento: 'DNI',
        numeroDocumento: '',
        email: '',
        telefono: '',
        departamento: 'Huánuco',
        provincia: 'Leoncio Prado',
        distrito: 'Rupa Rupa',
        direccion: '',
        esMenorEdad: false,
        nombreApoderado: '',
        tipoBien: 'Producto',
        montoReclamado: '',
        descripcionBien: '',
        tipoReclamacion: 'Reclamo',
        detalle: '',
        pedido: '',
        aceptaTerminos: false
    });

    useEffect(() => {
        window.scrollTo(0, 0);
        cargarContacto();
    }, []);

    const cargarContacto = () => {
        fetch(`${baseURL}/contactoGet.php`)
            .then(res => res.json())
            .then(data => {
                const lista = data.contacto || [];
                setContacto(lista[0] || {});
            })
            .catch(err => console.error('Error al cargar datos de contacto:', err));
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!formData.nombres.trim()) {
            Swal.fire('Campo requerido', 'Por favor ingrese sus nombres.', 'warning');
            return;
        }

        if (!formData.numeroDocumento.trim()) {
            Swal.fire('Campo requerido', 'Por favor ingrese su número de documento.', 'warning');
            return;
        }

        if (!formData.email.trim() || !formData.telefono.trim()) {
            Swal.fire('Contacto requerido', 'Por favor ingrese su correo electrónico y teléfono de contacto.', 'warning');
            return;
        }

        if (!formData.direccion.trim()) {
            Swal.fire('Dirección requerida', 'Por favor ingrese su dirección de domicilio.', 'warning');
            return;
        }

        if (!formData.descripcionBien.trim()) {
            Swal.fire('Campo requerido', 'Por favor describa el producto o servicio contratado.', 'warning');
            return;
        }

        if (!formData.detalle.trim()) {
            Swal.fire('Detalle requerido', 'Por favor detalle los hechos de su reclamo o queja.', 'warning');
            return;
        }

        if (!formData.pedido.trim()) {
            Swal.fire('Pedido requerido', 'Por favor indique la solución o pedido concreto que solicita.', 'warning');
            return;
        }

        if (!formData.aceptaTerminos) {
            Swal.fire('Aceptación requerida', 'Debe declarar que la información consignada es verdadera para registrar su reclamación.', 'warning');
            return;
        }

        setEnviando(true);

        fetch(`${baseURL}/libroReclamacionesPost.php`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
            .then(res => res.json())
            .then(data => {
                setEnviando(false);
                if (data.success) {
                    setReclamoExitoso({
                        ...formData,
                        codigo: data.codigo,
                        fecha: data.fecha,
                        idReclamo: data.idReclamo
                    });
                    window.scrollTo({ top: 120, behavior: 'smooth' });
                    Swal.fire({
                        title: '¡Reclamación Registrada!',
                        text: `Su número de registro oficial es: ${data.codigo}. Conforme a ley, daremos respuesta en un plazo no mayor a 15 días hábiles.`,
                        icon: 'success',
                        confirmButtonColor: '#3F1D76'
                    });
                } else {
                    Swal.fire('Error', data.error || 'No se pudo registrar la reclamación.', 'error');
                }
            })
            .catch(err => {
                setEnviando(false);
                console.error('Error al registrar reclamación:', err);
                Swal.fire('Error de conexión', 'Ocurrió un error al enviar el formulario. Intente nuevamente.', 'error');
            });
    };

    const handleImprimir = () => {
        window.print();
    };

    const handleNuevoRegistro = () => {
        setReclamoExitoso(null);
        setFormData({
            tipoPersona: 'Natural',
            nombres: '',
            apellidos: '',
            tipoDocumento: 'DNI',
            numeroDocumento: '',
            email: '',
            telefono: '',
            departamento: 'Huánuco',
            provincia: 'Leoncio Prado',
            distrito: 'Rupa Rupa',
            direccion: '',
            esMenorEdad: false,
            nombreApoderado: '',
            tipoBien: 'Producto',
            montoReclamado: '',
            descripcionBien: '',
            tipoReclamacion: 'Reclamo',
            detalle: '',
            pedido: '',
            aceptaTerminos: false
        });
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className="libro-page-wrapper">
            <div className="libro-page-container">
                {/* Cabecera Principal */}
                <div className="libro-header-banner">
                    <div className="libro-header-badge">
                        <FontAwesomeIcon icon={faShieldAlt} /> Conforme a Ley N° 29571 - Código de Protección y Defensa del Consumidor
                    </div>
                    <div className="libro-header-content">
                        <div className="libro-header-texts">
                            <h1>Libro de Reclamaciones Virtual</h1>
                            <p>
                                Ponemos a su disposición este canal digital para atender sus reclamos y quejas con la debida diligencia y transparencia conforme a la normativa de INDECOPI.
                            </p>
                        </div>
                        <div className="libro-header-logo-box">
                            <img src={libroLogoBlanco} alt="Libro de Reclamaciones Digital" className="libro-header-logo-img" />
                        </div>
                    </div>
                </div>

                {/* Tarjeta de Datos del Proveedor */}
                <div className="libro-proveedor-card">
                    <div className="libro-proveedor-header">
                        <FontAwesomeIcon icon={faBuilding} className="libro-prov-icon" />
                        <h3>Datos del Proveedor</h3>
                    </div>
                    <div className="libro-proveedor-grid">
                        <div className="libro-prov-item">
                            <span className="prov-label">Razón Social:</span>
                            <span className="prov-val">{contacto.nombre || 'SEYLIS S.A.C.'}</span>
                        </div>
                        <div className="libro-prov-item">
                            <span className="prov-label">RUC:</span>
                            <span className="prov-val">20603706041</span>
                        </div>
                        <div className="libro-prov-item">
                            <span className="prov-label">Dirección:</span>
                            <span className="prov-val">{contacto.direccion || 'Av. Tito Jaime 554, Tingo María, Huánuco, Perú'}</span>
                        </div>
                        <div className="libro-prov-item">
                            <span className="prov-label">Canal de Contacto:</span>
                            <span className="prov-val">{contacto.email || 'info@tingoaventuratours.com'} | Tel: {contacto.telefono || '962 615 167'}</span>
                        </div>
                    </div>
                </div>

                {reclamoExitoso ? (
                    /* ==================================================== */
                    /* VISTA DE CONFIRMACIÓN / HOJA DE RECLAMACIÓN OFICIAL */
                    /* ==================================================== */
                    <div className="libro-hoja-constancia" id="seccion-hoja-imprimible">
                        <div className="constancia-top-bar">
                            <div className="constancia-status">
                                <FontAwesomeIcon icon={faCheckCircle} className="text-success" />
                                <div>
                                    <h2>Hoja de Reclamación Registrada</h2>
                                    <span className="constancia-sub">Código Oficial: <strong>{reclamoExitoso.codigo}</strong></span>
                                </div>
                            </div>
                            <div className="constancia-actions-top">
                                <button type="button" onClick={handleImprimir} className="btn-constancia-print">
                                    <FontAwesomeIcon icon={faPrint} /> Imprimir Constancia
                                </button>
                                <button type="button" onClick={handleNuevoRegistro} className="btn-constancia-new">
                                    Registrar Otro
                                </button>
                            </div>
                        </div>

                        <div className="hoja-oficial-box">
                            <div className="hoja-watermark">HOJA DE RECLAMACIÓN</div>

                            <div className="hoja-header-legal">
                                <div>
                                    <h3>HOJA DE RECLAMACIÓN</h3>
                                    <p>LIBRO DE RECLAMACIONES VIRTUAL</p>
                                </div>
                                <div className="hoja-codigo-legal">
                                    <span>N° {reclamoExitoso.codigo}</span>
                                    <small>Fecha: {reclamoExitoso.fecha}</small>
                                </div>
                            </div>

                            <div className="hoja-seccion">
                                <h4 className="hoja-seccion-title">1. IDENTIFICACIÓN DEL CONSUMIDOR RECLAMANTE</h4>
                                <div className="hoja-grid-2">
                                    <div><strong>Nombre / Razón Social:</strong> {reclamoExitoso.nombres} {reclamoExitoso.apellidos}</div>
                                    <div><strong>Documento:</strong> {reclamoExitoso.tipoDocumento} - {reclamoExitoso.numeroDocumento}</div>
                                    <div><strong>Teléfono:</strong> {reclamoExitoso.telefono}</div>
                                    <div><strong>Correo Electrónico:</strong> {reclamoExitoso.email}</div>
                                    <div className="grid-full"><strong>Domicilio:</strong> {reclamoExitoso.direccion}, {reclamoExitoso.distrito}, {reclamoExitoso.provincia}, {reclamoExitoso.departamento}</div>
                                    {reclamoExitoso.esMenorEdad && (
                                        <div className="grid-full"><strong>Menor de Edad - Apoderado:</strong> {reclamoExitoso.nombreApoderado || 'Sí'}</div>
                                    )}
                                </div>
                            </div>

                            <div className="hoja-seccion">
                                <h4 className="hoja-seccion-title">2. IDENTIFICACIÓN DEL BIEN CONTRATADO</h4>
                                <div className="hoja-grid-2">
                                    <div><strong>Tipo de Bien:</strong> {reclamoExitoso.tipoBien}</div>
                                    <div><strong>Monto Reclamado:</strong> S/ {reclamoExitoso.montoReclamado ? Number(reclamoExitoso.montoReclamado).toFixed(2) : '0.00'}</div>
                                    <div className="grid-full"><strong>Descripción del Bien:</strong> {reclamoExitoso.descripcionBien}</div>
                                </div>
                            </div>

                            <div className="hoja-seccion">
                                <h4 className="hoja-seccion-title">3. DETALLE DE LA RECLAMACIÓN ({reclamoExitoso.tipoReclamacion.toUpperCase()})</h4>
                                <div className="hoja-box-text">
                                    <strong>Detalle de los hechos:</strong>
                                    <p>{reclamoExitoso.detalle}</p>
                                </div>
                                <div className="hoja-box-text">
                                    <strong>Pedido concreto del consumidor:</strong>
                                    <p>{reclamoExitoso.pedido}</p>
                                </div>
                            </div>

                            <div className="hoja-seccion-aviso">
                                <p>
                                    * <strong>RECLAMO:</strong> Disconformidad relacionada a los productos o servicios expendidos o suministrados.<br/>
                                    * <strong>QUEJA:</strong> Disconformidad no relacionada a los productos o servicios; o malestar o descontento respecto a la atención al público.<br/>
                                    * La formulación del reclamo no impide acudir a otras vías de solución de controversias ni es requisito previo para interponer una denuncia ante el INDECOPI.<br/>
                                    * El proveedor deberá dar respuesta al reclamo en un plazo no mayor a quince (15) días hábiles improrrogables.
                                </p>
                            </div>
                        </div>
                    </div>
                ) : (
                    /* ==================================================== */
                    /* FORMULARIO DE RECLAMACIÓN OFICIAL                    */
                    /* ==================================================== */
                    <form onSubmit={handleSubmit} className="libro-form-card">
                        {/* SECCIÓN 1: DATOS DEL CONSUMIDOR */}
                        <div className="libro-form-section">
                            <div className="libro-sec-header">
                                <span className="libro-sec-num">1</span>
                                <div>
                                    <h3>Identificación del Consumidor Reclamante</h3>
                                    <p>Ingrese sus datos personales o de la persona jurídica que presenta la reclamación.</p>
                                </div>
                            </div>

                            <div className="libro-grid-row">
                                <div className="libro-form-group">
                                    <label>Tipo de Persona *</label>
                                    <select 
                                        name="tipoPersona" 
                                        value={formData.tipoPersona} 
                                        onChange={handleChange}
                                        className="libro-input"
                                    >
                                        <option value="Natural">Persona Natural</option>
                                        <option value="Juridica">Persona Jurídica (Empresa)</option>
                                    </select>
                                </div>

                                <div className="libro-form-group">
                                    <label>{formData.tipoPersona === 'Natural' ? 'Nombres *' : 'Razón Social *'}</label>
                                    <input 
                                        type="text" 
                                        name="nombres" 
                                        value={formData.nombres} 
                                        onChange={handleChange}
                                        placeholder={formData.tipoPersona === 'Natural' ? 'Ej. Juan Carlos' : 'Ej. Empresa SAC'}
                                        required 
                                        className="libro-input"
                                    />
                                </div>

                                {formData.tipoPersona === 'Natural' && (
                                    <div className="libro-form-group">
                                        <label>Apellidos *</label>
                                        <input 
                                            type="text" 
                                            name="apellidos" 
                                            value={formData.apellidos} 
                                            onChange={handleChange}
                                            placeholder="Ej. Pérez Gómez"
                                            className="libro-input"
                                        />
                                    </div>
                                )}

                                <div className="libro-form-group">
                                    <label>Tipo de Documento *</label>
                                    <select 
                                        name="tipoDocumento" 
                                        value={formData.tipoDocumento} 
                                        onChange={handleChange}
                                        className="libro-input"
                                    >
                                        <option value="DNI">DNI (Documento Nacional de Identidad)</option>
                                        <option value="Carné de Extranjería">Carné de Extranjería</option>
                                        <option value="Pasaporte">Pasaporte</option>
                                        <option value="RUC">RUC</option>
                                    </select>
                                </div>

                                <div className="libro-form-group">
                                    <label>Número de Documento *</label>
                                    <input 
                                        type="text" 
                                        name="numeroDocumento" 
                                        value={formData.numeroDocumento} 
                                        onChange={handleChange}
                                        placeholder="Ej. 74859612"
                                        required 
                                        className="libro-input"
                                    />
                                </div>

                                <div className="libro-form-group">
                                    <label>Correo Electrónico *</label>
                                    <input 
                                        type="email" 
                                        name="email" 
                                        value={formData.email} 
                                        onChange={handleChange}
                                        placeholder="su-correo@ejemplo.com"
                                        required 
                                        className="libro-input"
                                    />
                                </div>

                                <div className="libro-form-group">
                                    <label>Teléfono Celular *</label>
                                    <input 
                                        type="tel" 
                                        name="telefono" 
                                        value={formData.telefono} 
                                        onChange={handleChange}
                                        placeholder="Ej. 962615167"
                                        required 
                                        className="libro-input"
                                    />
                                </div>

                                <div className="libro-form-group">
                                    <label>Departamento *</label>
                                    <input 
                                        type="text" 
                                        name="departamento" 
                                        value={formData.departamento} 
                                        onChange={handleChange}
                                        placeholder="Ej. Huánuco"
                                        className="libro-input"
                                    />
                                </div>

                                <div className="libro-form-group">
                                    <label>Provincia *</label>
                                    <input 
                                        type="text" 
                                        name="provincia" 
                                        value={formData.provincia} 
                                        onChange={handleChange}
                                        placeholder="Ej. Leoncio Prado"
                                        className="libro-input"
                                    />
                                </div>

                                <div className="libro-form-group">
                                    <label>Distrito *</label>
                                    <input 
                                        type="text" 
                                        name="distrito" 
                                        value={formData.distrito} 
                                        onChange={handleChange}
                                        placeholder="Ej. Rupa Rupa"
                                        className="libro-input"
                                    />
                                </div>

                                <div className="libro-form-group col-span-2">
                                    <label>Dirección de Domicilio *</label>
                                    <input 
                                        type="text" 
                                        name="direccion" 
                                        value={formData.direccion} 
                                        onChange={handleChange}
                                        placeholder="Ej. Av. Tito Jaime 554"
                                        required 
                                        className="libro-input"
                                    />
                                </div>
                            </div>

                            {/* Casilla Menor de Edad */}
                            {formData.tipoPersona === 'Natural' && (
                                <div className="libro-menor-box">
                                    <label className="checkbox-label">
                                        <input 
                                            type="checkbox" 
                                            name="esMenorEdad" 
                                            checked={formData.esMenorEdad} 
                                            onChange={handleChange}
                                        />
                                        <span>El consumidor es menor de edad (actúa mediante representante o apoderado).</span>
                                    </label>

                                    {formData.esMenorEdad && (
                                        <div className="libro-form-group" style={{ marginTop: '12px' }}>
                                            <label>Nombres y Apellidos del Padre/Madre o Apoderado *</label>
                                            <input 
                                                type="text" 
                                                name="nombreApoderado" 
                                                value={formData.nombreApoderado} 
                                                onChange={handleChange}
                                                placeholder="Nombre completo del apoderado"
                                                className="libro-input"
                                            />
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>

                        {/* SECCIÓN 2: IDENTIFICACIÓN DEL BIEN CONTRATADO */}
                        <div className="libro-form-section">
                            <div className="libro-sec-header">
                                <span className="libro-sec-num">2</span>
                                <div>
                                    <h3>Identificación del Bien Contratado</h3>
                                    <p>Especifique si su reclamación corresponde a un producto o servicio.</p>
                                </div>
                            </div>

                            <div className="libro-grid-row">
                                <div className="libro-form-group">
                                    <label>Tipo de Bien *</label>
                                    <div className="libro-radio-group">
                                        <label className={`radio-pill ${formData.tipoBien === 'Producto' ? 'active' : ''}`}>
                                            <input 
                                                type="radio" 
                                                name="tipoBien" 
                                                value="Producto" 
                                                checked={formData.tipoBien === 'Producto'} 
                                                onChange={handleChange} 
                                            />
                                            <span>Producto</span>
                                        </label>
                                        <label className={`radio-pill ${formData.tipoBien === 'Servicio' ? 'active' : ''}`}>
                                            <input 
                                                type="radio" 
                                                name="tipoBien" 
                                                value="Servicio" 
                                                checked={formData.tipoBien === 'Servicio'} 
                                                onChange={handleChange} 
                                            />
                                            <span>Servicio</span>
                                        </label>
                                    </div>
                                </div>

                                <div className="libro-form-group">
                                    <label>Monto Reclamado (S/) [Opcional]</label>
                                    <input 
                                        type="number" 
                                        step="0.01" 
                                        name="montoReclamado" 
                                        value={formData.montoReclamado} 
                                        onChange={handleChange}
                                        placeholder="0.00"
                                        className="libro-input"
                                    />
                                </div>

                                <div className="libro-form-group col-span-2">
                                    <label>Descripción del Producto o Servicio *</label>
                                    <input 
                                        type="text" 
                                        name="descripcionBien" 
                                        value={formData.descripcionBien} 
                                        onChange={handleChange}
                                        placeholder="Ej. Paquete Turístico a Cueva de las Pavas / Café Lingzhi DXN 2 en 1"
                                        required 
                                        className="libro-input"
                                    />
                                </div>
                            </div>
                        </div>

                        {/* SECCIÓN 3: DETALLE DE LA RECLAMACIÓN */}
                        <div className="libro-form-section">
                            <div className="libro-sec-header">
                                <span className="libro-sec-num">3</span>
                                <div>
                                    <h3>Detalle de la Reclamación</h3>
                                    <p>Seleccione el tipo de reclamación e ingrese los hechos y su pedido concreto.</p>
                                </div>
                            </div>

                            {/* Selector Reclamo vs Queja con Explicación Oficial INDECOPI */}
                            <div className="libro-tipo-selector-box">
                                <label className={`tipo-card ${formData.tipoReclamacion === 'Reclamo' ? 'active' : ''}`}>
                                    <input 
                                        type="radio" 
                                        name="tipoReclamacion" 
                                        value="Reclamo" 
                                        checked={formData.tipoReclamacion === 'Reclamo'} 
                                        onChange={handleChange} 
                                    />
                                    <div>
                                        <strong>RECLAMO</strong>
                                        <p>Disconformidad relacionada directamente a los productos o servicios adquiridos.</p>
                                    </div>
                                </label>

                                <label className={`tipo-card ${formData.tipoReclamacion === 'Queja' ? 'active' : ''}`}>
                                    <input 
                                        type="radio" 
                                        name="tipoReclamacion" 
                                        value="Queja" 
                                        checked={formData.tipoReclamacion === 'Queja'} 
                                        onChange={handleChange} 
                                    />
                                    <div>
                                        <strong>QUEJA</strong>
                                        <p>Disconformidad no relacionada al producto, sino a la mala atención al público o malestar.</p>
                                    </div>
                                </label>
                            </div>

                            <div className="libro-form-group" style={{ marginTop: '1.25rem' }}>
                                <label>Detalle de los Hechos del {formData.tipoReclamacion} *</label>
                                <textarea 
                                    name="detalle" 
                                    rows="5" 
                                    value={formData.detalle} 
                                    onChange={handleChange}
                                    placeholder={`Describa detalladamente lo sucedido respecto a su ${formData.tipoReclamacion.toLowerCase()}...`}
                                    required 
                                    className="libro-textarea"
                                />
                            </div>

                            <div className="libro-form-group" style={{ marginTop: '1rem' }}>
                                <label>Pedido Concreto del Consumidor *</label>
                                <textarea 
                                    name="pedido" 
                                    rows="3" 
                                    value={formData.pedido} 
                                    onChange={handleChange}
                                    placeholder="Indique con claridad qué solución o reparación solicita a la empresa..."
                                    required 
                                    className="libro-textarea"
                                />
                            </div>
                        </div>

                        {/* Declaración Legal de Veracidad */}
                        <div className="libro-legal-terms-box">
                            <label className="checkbox-label">
                                <input 
                                    type="checkbox" 
                                    name="aceptaTerminos" 
                                    checked={formData.aceptaTerminos} 
                                    onChange={handleChange}
                                    required 
                                />
                                <span>
                                    Declaro que la información consignada en la presente hoja de reclamación es verídica y acepto las <Link to="/politicas?id=2" target="_blank" rel="noopener noreferrer">Políticas de Protección de Datos Personales</Link> para fines de la atención y respuesta a mi reclamación dentro del plazo legal máximo de quince (15) días hábiles.
                                </span>
                            </label>
                        </div>

                        {/* Botón Enviar */}
                        <div className="libro-form-actions">
                            <button 
                                type="submit" 
                                disabled={enviando}
                                className="btn-libro-submit"
                            >
                                <FontAwesomeIcon icon={faPaperPlane} /> {enviando ? 'Enviando Reclamación...' : 'Enviar Reclamación'}
                            </button>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
}
